import { css } from 'aphrodite';
import * as React from 'react';
import { CameraIcon } from '../../../../../components/svgs/icons/CameraIcon';
import { mobileStyles } from '../styles';

interface MobileImageUploadButtonsProps {
	onClickFreeImage?: () => void;
	onClickMedia?: () => void;
	currentImageCount?: number;
	maxImages?: number;
}

const MobileImageUploadButtons: React.FC<MobileImageUploadButtonsProps> = ({ onClickFreeImage, onClickMedia }) => {
	return (
		<div className={css(mobileStyles.mobileImageUploadContainer)}>
			<div className={css(mobileStyles.mobileImageUploadButtonGroup)}>
				<button type='button' className={css(mobileStyles.mobileImageUploadButton)} onClick={onClickFreeImage}>
					<CameraIcon />
					<span style={{ marginLeft: 6 }}>Free Images</span>
				</button>
				<div className={css(mobileStyles.mobileImageUploadSourceText)}>Royalty free image library</div>
			</div>
			<div className={css(mobileStyles.mobileImageUploadButtonGroup)}>
				<button type='button' className={css(mobileStyles.mobileImageUploadButton)} onClick={onClickMedia}>
					+ Upload Media
				</button>
				<div className={css(mobileStyles.mobileImageUploadSourceText)}>Choose file from your computer</div>
			</div>
		</div>
	);
};

export { MobileImageUploadButtons };
